import React from "react";

const Terms = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h1 className="text-2xl font-extrabold text-gray-900">
        Terms & Conditions
      </h1>

      <p className="mt-4 text-gray-700 leading-relaxed">
        By accessing and using this website, you agree to comply with the
        following terms and conditions.
      </p>

      <h2 className="mt-6 text-xl font-semibold text-gray-800">
        1. Use of Content
      </h2>
      <p className="mt-2 text-gray-700">
        The content provided on this website is for informational purposes only.
        You may not copy, distribute, or use it for commercial purposes without
        permission.
      </p>

      <h2 className="mt-6 text-xl font-semibold text-gray-800">
        2. User Responsibilities
      </h2>
      <p className="mt-2 text-gray-700">
        Users are responsible for ensuring that their use of the website
        complies with all applicable laws and regulations.
      </p>

      <h2 className="mt-6 text-xl font-semibold text-gray-800">
        3. Limitation of Liability
      </h2>
      <p className="mt-2 text-gray-700">
        We are not responsible for any inaccuracies in Minilo AI-generated
        content. Users should verify information before making decisions based
        on it.
      </p>

      <div className="mt-6 p-4 border-l-4 border-blue-500 bg-blue-50">
        <p className="text-gray-800 font-medium">
          Continued use of this website implies acceptance of these terms. If
          you do not agree, please discontinue use.
        </p>
      </div>
    </div>
  );
};

export default Terms;
